var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEarly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7165_10921)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 0C4.69617 0 0 4.69658 0 10.5C0 16.3038 4.69658 21 10.5 21C16.3038 21 21 16.3034 21 10.5C21 4.69617 16.3034 0 10.5 0ZM10.5 19.3594C5.60302 19.3594 1.64062 15.3967 1.64062 10.5C1.64062 5.60302 5.60335 1.64062 10.5 1.64062C15.397 1.64062 19.3594 5.60335 19.3594 10.5C19.3594 15.397 15.3967 19.3594 10.5 19.3594Z",
    fill: "#EE0E11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 5.28601C10.0469 5.28601 9.67969 5.65326 9.67969 6.10632V11.3888C9.67969 11.8419 10.0469 12.2092 10.5 12.2092C10.9531 12.2092 11.3203 11.8419 11.3203 11.3888V6.10632C11.3203 5.65326 10.9531 5.28601 10.5 5.28601Z",
    fill: "#EE0E11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 15.4285C11.1116 15.4285 11.6074 14.9327 11.6074 14.321C11.6074 13.7094 11.1116 13.2136 10.5 13.2136C9.88839 13.2136 9.39258 13.7094 9.39258 14.321C9.39258 14.9327 9.88839 15.4285 10.5 15.4285Z",
    fill: "#EE0E11"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7165_10921"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarly);
export default __webpack_public_path__ + "static/media/early.f6c856cdc1a2912d0b18b84ac7db5f6f.svg";
export { ForwardRef as ReactComponent };